import { Link } from '@/lib/nav';
import { ArrowRight } from 'lucide-react';
import { Container, Section, Eyebrow } from '@/components/primitives/Container';
import { WaitlistForm } from '@/components/forms/WaitlistForm';
import { ROUTES } from '@/lib/routes';

const CAPABILITIES = [
  'Comparación inter-jurisdiccional para un mismo NAP.',
  'Análisis longitudinal de versiones de un diseño jurisdiccional.',
  'Exportación de análisis con citas textuales.',
  'Identificación de patrones de implementación entre regiones.',
];

const CURATION = [
  'Quiénes validan: especialistas curriculares con experiencia en diseño jurisdiccional.',
  'Qué se valida: jerarquía, denominaciones, alcances y relaciones NAP↔diseño.',
  'En qué condiciones: trabajo asíncrono pautado, con reconocimiento explícito de autoría.',
];

export function Especialistas() {
  return (
    <>
      <section className="rule-bottom">
        <Container className="pt-16 pb-16 md:pt-24 md:pb-20">
          <Eyebrow className="mb-8">Para especialistas</Eyebrow>
          <h1 className="max-w-5xl font-display text-5xl font-medium leading-[1.05] tracking-tight text-accent md:text-6xl lg:text-7xl">
            24 jurisdicciones contra el NAP
            <br />
            <span className="font-normal italic">en minutos, no en meses.</span>
          </h1>
          <p className="mt-8 max-w-prose text-lg leading-relaxed text-ink-muted md:text-xl">
            Para investigadores, equipos técnicos ministeriales y autores de diseños jurisdiccionales.
          </p>
        </Container>
      </section>

      <Section className="pt-0">
        <Container width="editorial">
          <ul className="flex flex-col">
            {CAPABILITIES.map((c) => (
              <li
                key={c}
                className="border-t border-line py-5 font-serif text-lg leading-snug text-ink first:border-t-0"
              >
                {c}
              </li>
            ))}
          </ul>
        </Container>
      </Section>

      <Section ariaLabelledby="curaduria-title" className="bg-paper-tinted/40">
        <Container width="editorial">
          <Eyebrow>Sumarse al pool de curaduría</Eyebrow>
          <h2 id="curaduria-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            SICA se mantiene rigurosa porque la valida humanamente un pool de especialistas.
          </h2>
          <ul className="mt-6 flex flex-col gap-4">
            {CURATION.map((c) => (
              <li
                key={c}
                className="border-l-2 border-accent pl-4 text-base leading-relaxed text-ink-muted"
              >
                {c}
              </li>
            ))}
          </ul>
          <Link
            to={`${ROUTES.contacto}?perfil=especialista&motivo=curaduria`}
            className="focus-ring mt-8 inline-flex items-center gap-1.5 rounded-full border border-line_strong px-5 py-2.5 text-sm font-medium text-ink hover:border-ink hover:bg-ink hover:text-paper"
          >
            Sumarme al pool de curaduría
            <ArrowRight size={14} />
          </Link>
        </Container>
      </Section>

      <Section ariaLabelledby="ministerial-title">
        <Container width="editorial">
          <Eyebrow>Para tu equipo o ministerio</Eyebrow>
          <h2 id="ministerial-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Si representás un ministerio o un equipo técnico, abrimos una conversación específica.
          </h2>
          <Link
            to={`${ROUTES.contacto}?perfil=especialista&motivo=institucional`}
            className="focus-ring mt-6 inline-flex items-center gap-1 rounded text-sm font-medium text-ink hover:text-accent"
          >
            Iniciar conversación técnico-ministerial
            <ArrowRight size={14} />
          </Link>
        </Container>
      </Section>

      <Section ariaLabelledby="waitlist-title" className="border-t border-line">
        <Container width="editorial">
          <Eyebrow>Acceso técnico</Eyebrow>
          <h2 id="waitlist-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Acceso a la herramienta de análisis comparado.
          </h2>
          <WaitlistForm audience="especialistas" className="mt-8" />
        </Container>
      </Section>
    </>
  );
}
